import { useEffect } from 'react';

export function useUnsavedChangesGuard(isDirty: boolean) {
  // Warn on browser close/refresh when form has unsaved changes
  useEffect(() => {
    if (!isDirty) return;

    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };

    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [isDirty]);
}
